<template>
	<div class="delete_person">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">删除人员信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID删除该人员的全部信息（如果有绑定FRM，该人员在FRM云端的全部信息也会在下一次心跳后被删除）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (int)skFaceDeletePerson:(NSString *)personID;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">personID：人员ID</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	返回：0：删除成功。返回其他：删除失败。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int deletePerson = [SKFaceManagerInterface skFaceDeletePerson:@"11111"];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','本地接口','删除人员信息'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.delete_person{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/localface/deletePerson.vue